export default __webpack_public_path__ + "static/infoCaptured-6f247fb0f4a526775663b393670ac02e.jpg";